/*
 * @Descripttion:
 * @version:
 * @Author: 付正生
 * @Date: 2022-06-20 17:43:51
 * @LastEditors: James chen
 * @LastEditTime: 2022-07-01 10:39:38
 */
export const tanRouter = [
  {
    path: "/salesContractDetails",
    name: "salesContractDetails",
    component: () =>
      import("@/views/salesManagement/salesContract/salesContractDetails"),
    meta: { title: "生产订单详情", keepAlive: false },
  },
  {
    path: "/distribute",
    name: "distribute",
    component: () => import("@/views/planManage/proOrder/distribute"),
    meta: { title: "派发至车间", keepAlive: false },
  },
  {
    path: "/workshopPlanDetail",
    name: "workshopPlanDetail",
    component: () => import("@/views/planManage/workshopPlan/detail"),
    meta: { title: "计划详情", keepAlive: false },
  },
  {
    path: "/workshopPlanAdd",
    name: "workshopPlanAdd",
    component: () => import("@/views/planManage/workshopPlan/add"),
    meta: { title: "手动排产", keepAlive: false },
  },
  {
    path: "/stockCheckForm",
    name: "stockCheckForm",
    component: () =>
      import("@/views/warehouseManagement/stockCheck/stockCheckForm"),
    meta: { title: "新建盘点单", keepAlive: false },
  },
  {
    path: "/inventoryOrderForm",
    name: "inventoryOrderForm",
    component: () =>
      import("@/views/warehouseManagement/inventoryOrder/inventoryOrderForm"),
    meta: { title: "新建入库单", keepAlive: false },
  },
  {
    path: "/inventoryOrderDetail",
    name: "inventoryOrderDetail",
    component: () =>
      import("@/views/warehouseManagement/inventoryOrder/inventoryOrderDetail"),
    meta: { title: "入库单详情", keepAlive: false },
  },
  {
    path: "/newReportForm",
    name: "newReportForm",
    component: () => import("@/views/workManagement/productTask/newReportForm"),
    meta: { title: "新建报工", keepAlive: false },
  },
  {
    path: "/outboundOrderForm",
    name: "outboundOrderForm",
    component: () =>
      import("@/views/warehouseManagement/outboundOrder/outboundOrderForm"),
    meta: { title: "新建出库单", keepAlive: false },
  },
  {
    path: "/outboundOrderDetail",
    name: "outboundOrderDetail",
    component: () =>
      import("@/views/warehouseManagement/outboundOrder/outboundOrderDetail"),
    meta: { title: "出库单详情", keepAlive: false },
  },
  {
    path: "/reportDetail",
    name: "reportDetail",
    component: () => import("@/views/workManagement/productTask/reportDetail"),
    meta: { title: "报工详情", keepAlive: false },
  },
  {
    path: "/productTask/taskDetail",
    name: "productTaskTaskDetail",
    component: () => import("@/views/workManagement/productTask/taskDetail"),
    meta: { title: "任务详情", keepAlive: false },
  },
  {
    path: "/outboundTasksForm",
    name: "outboundTasksForm",
    component: () =>
      import("@/views/warehouseManagement/outboundTasks/outboundTasksForm"),
    meta: { title: "新建出库任务", keepAlive: false },
  },
  {
    path: "/outboundTasksPicking",
    name: "outboundTasksPicking",
    component: () =>
      import("@/views/warehouseManagement/outboundTasks/outboundTasksPicking"),
    meta: { title: "下发拣货", keepAlive: false },
  },
  {
    path: "/outboundTasksDetail",
    name: "outboundTasksDetail",
    component: () =>
      import("@/views/warehouseManagement/outboundTasks/outboundTasksDetail"),
    meta: { title: "出库任务详情", keepAlive: false },
  },
  {
    path: "/outboundTasksAlready",
    name: "outboundTasksAlready",
    component: () =>
      import("@/views/warehouseManagement/outboundTasks/outboundTasksAlready"),
    meta: { title: "出库任务详情", keepAlive: false },
  },
  {
    path: "/pickingForm",
    name: "pickingForm",
    component: () =>
      import("@/views/warehouseManagement/outboundTasks/pickingForm"),
    meta: { title: "下发拣货", keepAlive: false },
  },
  {
    path: "/pickingTasksForm",
    name: "pickingTasksForm",
    component: () =>
      import("@/views/warehouseManagement/pickingTasks/pickingTasksForm"),
    meta: { title: "拣货任务", keepAlive: false },
  },

  {
    path: "/pickingTasksDetail",
    name: "pickingTasksDetail",
    component: () =>
      import("@/views/warehouseManagement/pickingTasks/pickingTasksDetail"),
    meta: { title: "拣货任务详情", keepAlive: false },
  },
  {
    path: "/pickingTasksVerification",
    name: "pickingTasksVerification",
    component: () =>
      import(
        "@/views/warehouseManagement/pickingTasks/pickingTasksVerification"
      ),
    meta: { title: "拣货任务核验", keepAlive: false },
  },
  {
    path: "/pickingTasksAlready",
    name: "pickingTasksAlready",
    component: () =>
      import("@/views/warehouseManagement/pickingTasks/pickingTasksAlready"),
    meta: { title: "已核验出库", keepAlive: false },
  },
  {
    path: "/warehousingTaskForm",
    name: "warehousingTaskForm",
    component: () =>
      import("@/views/inventoryOrder/warehousingTask/warehousingTaskForm"),
    meta: { title: "新建入库任务", keepAlive: false },
  },
  {
    path: "/warehousingTaskDetail",
    name: "warehousingTaskDetail",
    component: () =>
      import("@/views/inventoryOrder/warehousingTask/warehousingTaskDetail"),
    meta: { title: "入库任务详情", keepAlive: false },
  },
  {
    path: "/receiptedGoods",
    name: "receiptedGoods",
    component: () =>
      import("@/views/inventoryOrder/warehousingTask/receiptedGoods"),
    meta: { title: "收货", keepAlive: false },
  },
  {
    path: "/receiptedGoodsDetail",
    name: "receiptedGoodsDetail",
    component: () =>
      import("@/views/inventoryOrder/warehousingTask/receiptedGoodsDetail"),
    meta: { title: "已收货", keepAlive: false },
  },
  {
    path: "/warehouseWarrantForm",
    name: "warehouseWarrantForm",
    component: () =>
      import(
        "@/views/inventoryOrder/warehouseWarrant/warehouseWarrantForm.vue"
      ),
    meta: { title: "新建入库单", keepAlive: false },
  },
  {
    path: "/warehouseWarrantDetail",
    name: "warehouseWarrantDetail",
    component: () =>
      import(
        "@/views/inventoryOrder/warehouseWarrant/warehouseWarrantDetail.vue"
      ),
    meta: { title: "入库单详情", keepAlive: false },
  },
  {
    path: "/warehouseWarrantPrintList",
    name: "warehouseWarrantPrintList",
    component: () =>
      import("@/views/inventoryOrder/warehouseWarrant/printList.vue"),
    meta: { title: "预览物品标签", keepAlive: false },
  },
  {
    path: "/shelfTaskForm",
    name: "shelfTaskForm",
    component: () =>
      import("@/views/inventoryOrder/shelfTask/shelfTaskForm.vue"),
    meta: { title: "上架", keepAlive: false },
  },
  {
    path: "/shelfTaskDetail",
    name: "shelfTaskDetail",
    component: () =>
      import("@/views/inventoryOrder/shelfTask/shelfTaskDetail.vue"),
    meta: { title: "上架任务详情", keepAlive: false },
  },
  {
    path: "/shelfTaskGoodsDetail",
    name: "shelfTaskGoodsDetail",
    component: () =>
      import("@/views/inventoryOrder/shelfTask/shelfTaskGoodsDetail.vue"),
    meta: { title: "已上架", keepAlive: false },
  },
  {
    path: "/shelfTaskPrintList",
    name: "shelfTaskPrintList",
    component: () => import("@/views/inventoryOrder/shelfTask/printList.vue"),
    meta: { title: "预览物品标签", keepAlive: false },
  },
  {
    path: "/inventoryRulesForm",
    name: "inventoryRulesForm",
    component: () =>
      import(
        "@/views/inventoryCheck/inventoryCheckOrder/inventoryRulesForm.vue"
      ),
    meta: { title: "盘点规则", keepAlive: false },
  },
  {
    path: "/inventoryCheckOrderDetail",
    name: "inventoryCheckOrderDetail",
    component: () =>
      import(
        "@/views/inventoryCheck/inventoryCheckOrder/inventoryCheckOrderDetail.vue"
      ),
    meta: { title: "盘点单详情", keepAlive: false },
  },
  {
    path: "/inventoryItaskForm",
    name: "inventoryItaskForm",
    component: () =>
      import(
        "@/views/inventoryCheck/inventoryCheckOrder/inventoryItaskForm.vue"
      ),
    meta: { title: "盘点", keepAlive: false },
  },
  {
    path: "/goodsBatchPrintList", //物品批号-批量选择页面
    name: "goodsBatchPrintList",
    component: () =>
      import("@/views/inventoryInfo/goodsBatchList/goodsBatchPrint.vue"),
    meta: { title: "物品批号", keepAlive: false },
  },
  {
    path: "/inventoryOverTopForm",
    name: "inventoryOverTopForm",
    component: () =>
      import(
        "@/views/inventoryCheck/inventoryOverTop/inventoryOverTopForm.vue"
      ),
    meta: { title: "新建盘盈单", keepAlive: false },
  },
  {
    path: "/inventoryOverTopDetail",
    name: "inventoryOverTopDetail",
    component: () =>
      import(
        "@/views/inventoryCheck/inventoryOverTop/inventoryOverTopDetail.vue"
      ),
    meta: { title: "盘盈单详情", keepAlive: false },
  },
  {
    path: "/inventoryLossForm",
    name: "inventoryLossForm",
    component: () =>
      import("@/views/inventoryCheck/inventoryLoss/inventoryLossForm.vue"),
    meta: { title: "新建盘亏单", keepAlive: false },
  },
  {
    path: "/inventoryLossDetail",
    name: "inventoryLossDetail",
    component: () =>
      import("@/views/inventoryCheck/inventoryLoss/inventoryLossDetail.vue"),
    meta: { title: "盘亏单详情", keepAlive: false },
  },
  {
    path: "/removeWarehouseDetail",
    name: "removeWarehouseDetail",
    component: () =>
      import("@/views/removeWarehouse/removeWarehouseDetail.vue"),
    meta: { title: "移仓单详情", keepAlive: false },
  },
  {
    path: "/removeWarehouseForm",
    name: "removeWarehouseForm",
    component: () => import("@/views/removeWarehouse/removeWarehouseForm.vue"),
    meta: { title: "新建移仓单", keepAlive: false },
  },
  {
    path: "/goodsPrintPage",
    name: "goodsPrintPage",
    component: () =>
      import("@/views/inventoryInfo/goodsBatchList/printList.vue"),
    meta: { title: "预览物品标签", keepAlive: false },
  },
];
